import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import HotRanking from "@/pages/home/components/HotRanking";
import LatestSection from "@/pages/home/components/LatestSection";
import TopicSection from "@/pages/home/components/TopicSection";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo({
    title: "欲望的诱惑-最新影视剧资讯与剧情介绍",
    description:
      "欲望的诱惑网站提供全面的影视剧资讯、剧情介绍和演员信息，覆盖热门影视作品，帮助用户快速了解和查找影视资源。",
    keywords: "欲望的诱惑,影视剧,剧情介绍,演员表,影视资讯,影视作品,电视剧,电影",
    canonicalPath: "/",
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroCarousel />
        <CategoryGrid />
        <HotRanking />
        <TopicSection />
        <LatestSection />
        <SiteIntro />
      </main>
      <Footer />
    </div>
  );
}